module.exports = __webpack_public_path__ + "static/media/banner_matches_visitor.e53d4dcb.png";